import httpClient from './httpClient';

export default {
  getInfo: (apiKey, externalId) => httpClient.get(`/api/business/info/${apiKey}/${externalId}`),
  getIntegrationSettings: (apiKey, externalId) => httpClient.get(`/api/business/get/${apiKey}/${externalId}`),
};
